import { Collapse, Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import colorConstants from 'styles/ColorConstants';
import { museoSansFont500 } from 'util/EnumHelper';
import PropTypes from 'prop-types';

const AccordionSection = styled(Box)(() =>({
    display: 'flex',
    flexDirection: 'column',
    marginTop: 8
}));

const AccordionTitle = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    paddingTop: 8,
    paddingBottom: 8
}));

const AccordionContent = styled(Box)(() => ({
    padding: 8
}));

const StyledTabTitle = styled(Typography)(() => ({
    color: colorConstants.EVERDRIVENDARKCHARCOAL,
    fontFamily: museoSansFont500,
    fontSize: 24,
    margin: 0
}));

function StyledAccordion ({ title, children, isDefaultOpen }) {
    const [ isOpen, setIsOpen ] = useState(isDefaultOpen);

    useEffect(() => {
        setIsOpen(isDefaultOpen);
    }, [isDefaultOpen]);

    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };

    return (
        <AccordionSection>
            <AccordionTitle onClick={toggleAccordion}>
                <StyledTabTitle>{title}</StyledTabTitle>
                {isOpen ? <ExpandLessIcon sx={{ fontSize: 19 }} /> : <ExpandMoreIcon sx={{ fontSize: 19 }} />}
            </AccordionTitle>
            <Collapse in={isOpen} timeout="auto" unmountOnExit>
                <AccordionContent>
                    {children}
                </AccordionContent>
            </Collapse>
        </AccordionSection>
    );
}

StyledAccordion.defaultProps = {
    children: null,
    isDefaultOpen: false,
    title: null
};

StyledAccordion.propTypes = {
    children: PropTypes.node,
    isDefaultOpen: PropTypes.bool,
    title: PropTypes.string
};

export default StyledAccordion;